<template>
  <div class="xcard">
    <h3 class="text-center" style="margin-top:0"> Reporte de Marketing </h3>
    <p class="text-center text-primary"> <small>Seleccione la sede y el rango de fechas</small> </p>
    <hr>

    <div class="row">
      <div class="col-sm-5">
        <Sedes :model="sede"/>
        <p> <small></small> </p>
        <Usuarios :model="sede" :idsede="sede.idsede.id" :multiple="true"/>
      </div>

      <div class="col-sm-7">
        <div class="col-sm-5" :class="{'has-error': validation.hasError('busqueda.fecha_ini')}">
          <Fecha :model="busqueda" :valueto="'fecha_ini'" :default="busqueda.fecha_ini"/>
          <small>Desde (una semana atras)</small>
          <div class="error" v-if="validation.hasError('busqueda.fecha_ini')"> {{validation.firstError('busqueda.fecha_ini')}} </div>
        </div>
        <div class="col-sm-5" :class="{'has-error': validation.hasError('busqueda.fecha_fin')}">
          <Fecha :model="busqueda" :valueto="'fecha_fin'" :default="busqueda.fecha_fin"/>
          <small>Hasta (ahora)</small>
          <div class="error" v-if="validation.hasError('busqueda.fecha_fin')"> {{validation.firstError('busqueda.fecha_fin')}} </div>
        </div>
        <div class="col-sm-2">
          <button class="btn btn-sm btn-primary" @click="clickBuscar()"> Buscar </button>
        </div>
      </div>
    </div>

  

    <div class="table-responsive compress">
      <p class="text-primary"> <small>Seleccione los asesores, las fechas de inicio y fin, despues seleccione el boton de buscar para ver los resultados</small> </p>
       <Alertas ref="alertar" />
      <table class="table table-striped table-bordered datatable"> 
        <thead></thead>
        <tbody>
          <tr style="background:#3D85C6;color:white;vertical-align:middle;" class="text-center">
            <th rowspan="4" class="text-center" style="vertical-align: middle;">No</th>
            <th rowspan="4" class="text-center" style="vertical-align: middle;min-width:200px">Nombres y Apellidos</th>
          </tr>
          <tr style="background: #E5E8EB;">
            <td colspan="3" class="text-center" style="background:#4A8F2E;color:white">Cursos  </td>
            <td colspan="4" class="text-center" style="background:#7F6000;color:white">Diplomados  </td>
            <td colspan="4" class="text-center" style="background:#37598F;color:white">Especialidades  </td>
            <td colspan="4" class="text-center" style="background:#695F87;color:white">Maestrias  </td>
            <th colspan="2" rowspan="3" class="text-center" style="background:#E69138;vertical-align: middle;min-width:320px;">Resumen Semanal</th>
          </tr>
          <tr style="background: #E5E8EB;">
            <td style="background:#759068;color:white" > <small> Inscritos </small> </td>
            <td rowspan="2" style="background:#759068;color:white;min-width:120px;max-width:120px!important" > <small> Nombre Curso </small> </td>
            <td style="background:#759068;color:white" > <small> Cobros </small> </td>

            <td style="background:#BF9000;color:white" > <small> Inscritos </small> </td>
            <td colspan="3" style="background:#BF9000;color:white;min-width:120px;max-width:120px!important" > <small> Cobros </small> </td>

            <td style="background:#6180B1;color:white" > <small> Inscritos </small> </td>
            <td colspan="3"  style="background:#6180B1;color:white;min-width:120px;max-width:120px!important" > <small> Cobros </small> </td>

            <td style="background:#948BA8;color:white" > <small> Inscritos </small> </td>
            <td colspan="3" style="background:#948BA8;color:white;min-width:120px;max-width:120px!important" > <small> Cobros </small> </td>
          </tr>
          <tr>
            <td style="background:#75A068;color:white" > <small>Cantidad</small> </td>
            <td style="background:#75A068;color:white" > <small>Inscripciones</small> </td>

            <td style="background:#E1B52F;color:white" > <small>Cantidad</small> </td>
            <td style="background:#E1B52F;color:white" > <small>Diplomado En:</small> </td>
            <td style="background:#E1B52F;color:white" > <small>Matricula</small> </td>
            <td style="background:#E1B52F;color:white" > <small>Colegiatura</small> </td>

            <td style="background:#6180D9;color:white" > <small>Cantidad</small> </td>
            <td style="background:#6180D9;color:white" > <small>Especialidad En:</small> </td>
            <td style="background:#6180D9;color:white" > <small>Matricula</small> </td>
            <td style="background:#6180D9;color:white" > <small>Colegiatura</small> </td>

            <td style="background:#949DA8;color:white" > <small>Cantidad</small> </td>
            <td style="background:#949DA8;color:white" > <small>Maestria En:</small> </td>
            <td style="background:#949DA8;color:white" > <small>Matricula</small> </td>
            <td style="background:#949DA8;color:white" > <small>Colegiatura</small> </td>
          </tr>







          <tr class="bordear" v-bind:key="ind" v-for="(a,ind) in usuarios">
            <td> {{ind+1}} </td>
            <td> {{parseUs(a)}} <small v-if="a.loading" class="text-danger"><b>...</b></small> </td>

            <td class="unaLinea" style="background:#B6D7A8"> <span :key="inde" v-for="(c,inde) in a.cd" > <small>{{c.count}}</small> <hr v-if="inde < a.cd.length-1" class="hrcolor"/> </span> </td>
            <td class="unaLinea nomCurso" style="background:#B6D7A8"> <span :key="inde" v-for="(c,inde) in a.cd" :title="c.curso"> <small>{{c.curso}}</small> <hr v-if="inde < a.cd.length-1" class="hrcolor"/> </span> </td>
            <td class="unaLinea" style="background:#B6D7A8"> <span :key="inde" v-for="(c,inde) in a.cd" > <small>{{c.cobro}}</small> <hr v-if="inde < a.cd.length-1" class="hrcolor"/> </span> </td>

            <td class="unaLinea" style="background:#F4E0A6"> <span :key="inde" v-for="(c,inde) in a.ca" > <small>{{c.count}}</small> <hr v-if="inde < a.ca.length-1" class="hrcolor"/> </span> </td>
            <td class="unaLinea nomCurso" style="background:#F4E0A6"> <span :key="inde" v-for="(c,inde) in a.ca" :title="c.curso"> <small>{{c.curso}}</small> <hr v-if="inde < a.ca.length-1" class="hrcolor"/> </span> </td>
            <td class="unaLinea" style="background:#F4E0A6"> <span :key="inde" v-for="(c,inde) in a.ca" > <small>{{c.matri}}</small> <hr v-if="inde < a.ca.length-1" class="hrcolor"/> </span> </td>
            <td class="unaLinea" style="background:#F4E0A6"> <span :key="inde" v-for="(c,inde) in a.ca" > <small>{{c.cobro}}</small> <hr v-if="inde < a.ca.length-1" class="hrcolor"/> </span> </td>

            <td class="unaLinea" style="background:#A4C2F4"> <span :key="inde" v-for="(c,inde) in a.cb" > <small>{{c.count}}</small> <hr v-if="inde < a.cb.length-1" class="hrcolor"/> </span> </td>
            <td class="unaLinea nomCurso" style="background:#A4C2F4"> <span :key="inde" v-for="(c,inde) in a.cb" :title="c.curso"> <small>{{c.curso}}</small> <hr v-if="inde < a.cb.length-1" class="hrcolor"/> </span> </td>
            <td class="unaLinea" style="background:#A4C2F4"> <span :key="inde" v-for="(c,inde) in a.cb" > <small>{{c.matri}}</small> <hr v-if="inde < a.cb.length-1" class="hrcolor"/> </span> </td>
            <td class="unaLinea" style="background:#A4C2F4"> <span :key="inde" v-for="(c,inde) in a.cb" > <small>{{c.cobro}}</small> <hr v-if="inde < a.cb.length-1" class="hrcolor"/> </span> </td>
            
            <td class="unaLinea" style="background:#D9D2E9"> <span :key="inde" v-for="(c,inde) in a.cc" > <small>{{c.count}}</small> <hr v-if="inde < a.cc.length-1" class="hrcolor"/> </span> </td>
            <td class="unaLinea nomCurso" style="background:#D9D2E9"> <span :key="inde" v-for="(c,inde) in a.cc" :title="c.curso"> <small>{{c.curso}}</small> <hr v-if="inde < a.cc.length-1" class="hrcolor"/> </span> </td>
            <td class="unaLinea" style="background:#D9D2E9"> <span :key="inde" v-for="(c,inde) in a.cc" > <small>{{c.matri}}</small> <hr v-if="inde < a.cc.length-1" class="hrcolor"/> </span> </td>
            <td class="unaLinea" style="background:#D9D2E9"> <span :key="inde" v-for="(c,inde) in a.cc" > <small>{{c.cobro}}</small> <hr v-if="inde < a.cc.length-1" class="hrcolor"/> </span> </td>



            <td :title="a.nombres" class="unaLinea tot nomCurso" style="background:#F6B26B"> <span :key="inde" v-for="(c,inde) in a.tots" :title="c.curso"> <small>{{c.nom}}</small> <hr v-if="inde < a.tots.length-1" class="hrcolor"/> </span> </td>
            <td class="unaLinea tot" style="background:#F6B26B"> <span :key="inde" v-for="(c,inde) in a.tots" > <small>{{c.t}}</small> <hr v-if="inde < a.tots.length-1" class="hrcolor"/> </span> </td>
          </tr>

          <tr>
            <td colspan="2" style="height:32px"></td>
            <td> </td>
            <td></td>
            <td></td>
            <td> </td>
            <td></td>
            <td></td>
            <td></td>
            <td> </td>
            <td></td>
            <td></td>
            <td></td>
            <td> </td>
            <td></td>
            <td></td>
            <td></td>
            <td> </td>
          </tr>

          <tr>
            <td colspan="2"></td>
            <td colspan="3" style="background:#93C47D;color:black">Sede</td>
            <td colspan="14" style="background:#F4CCCC;color:black">Sede</td>
          </tr>
          <tr>
            <td colspan="2"></td>
            <td style="background:#93C47D;color:black"> {{totales.d}} </td>
            <td style="background:#93C47D"></td>
            <td style="background:#93C47D;color:black"> {{totales.dd}} </td>
            <td style="background:#FFD966"> {{totales.a}} </td>
            <td style="background:#FFD966"></td>
            <td style="background:#FFD966"> {{totales.aa}} </td>
            <td style="background:#FFD966"> {{totales.aaa}} </td>
            <td style="background:#6D9EEB"> {{totales.b}} </td>
            <td style="background:#6D9EEB"></td>
            <td style="background:#6D9EEB"> {{totales.bb}} </td>
            <td style="background:#6D9EEB"> {{totales.bbb}} </td>
            <td style="background:#B4A7D6"> {{totales.c}} </td>
            <td style="background:#B4A7D6"></td>
            <td style="background:#B4A7D6"> {{totales.cc}} </td>
            <td style="background:#B4A7D6"> {{totales.ccc}} </td>

            <td style="background:#F6B26B;color:black"> <small> TOTAL INSCRITOS </small> </td>
            <td style="background:#F9CB9C;color:black"> {{totales.e}} </td>
          </tr>
          <tr>
            <td colspan="17"></td>
            <td style="background:#F6B26B;color:black"> <small> MATRÍCULAS (Bs.) </small> </td>
            <td style="background:#F9CB9C;color:black"> {{totales.ee}} </td>
          </tr>
          <tr>
            <td colspan="17"></td>
            <td style="background:#F6B26B;color:black"> <small> COLEGIATURAS (Bs.) </small> </td>
            <td style="background:#F9CB9C;color:black"> {{totales.eee}} </td>
          </tr>

        </tbody>
      </table>
    </div>

    <notifications group="auth" position="bottom right" />
  </div>
</template>

<style lang="css">
.compress td{
  padding-top: 6px!important;
  padding-bottom: 0px!important;
  text-align: center;
}
.compress hr{
  margin: 0!important;
}

.unaLinea {
  padding: 0!important;
}

.nomCurso{
    text-align: start!important;
    white-space: nowrap;
    max-width: 120px;
    overflow: hidden;
    padding-right: 4px;
}
.nomCurso:hover{
  cursor: pointer;
}

.bordear .hrcolor{
  border-top: 1px dashed #666666;
}
.bordear td {
  border-bottom: 1px solid black !important;
  padding-top: 12px!important;
}
.unaLinea span:last-child {
    background: #EA9999!important;
    width: 100%;
    height: 26px;
    display: inline-block;
}
.tot span:last-child {
    background: #6AA84F!important;
    width: 100%;
    display: inline-block;
}
.bordear{
  border-bottom: 3px solid black;
}
</style>

<script>
import Sedes from '@/components/ASedes'
import Usuarios from '@/components/AUsuariosSemaforoMarketing.vue'
import Alertas from '@/components/AAlertas.vue'
import {parseJsonError,error} from '@/components/Utils.js'
import Fecha from '@/components/AFecha.vue'
import { Validator } from 'simple-vue-validator'
import gql from 'graphql-tag'
export default {
  data(){
    return{
      usuarios:[],
      sede: {idsede:{},idusuario:[]},
      busqueda: { fecha_ini: null,fecha_fin: null, },
      totales: {a:0,b:0,c:0,d:0,e:0,ee:0,eee:0,dd:0,aa:0,bb:0,cc:0,ddd:0,aaa:0,bbb:0,ccc:0},
    }
  },
  components:{ Sedes,Fecha,Usuarios,Alertas },
  validators: {
      'busqueda.fecha_ini'(value){ return Validator.value(value).required(); },
      'busqueda.fecha_fin'(value){ return Validator.value(value).required(); },
  },
  watch:{ 
    'sede.idusuario': function( a ){
      window.console.log( a )

      this.usuarios =[]
      var vue = this;
      a.forEach( function(e){ 
        vue.usuarios.push( 
          {
            id:e.id,
            nombres:e.nombres,
            meta1:'-',
            meta2:'-',
            meta3:'-',
            meta4:'-',
            loading: false,
            ca:[],
            cb:[],
            cc:[],
            cd:[],
            tic:[],
            tip:[],
            nom: '-',
            cobros: '-',
            coles: '-',
            total: 0,
            totalm: 0,
            totalc: 0,
            tots:[
              {id:1,nom:'Total Inscripciones Cursos',t:0},
              {id:2,nom:'Total Inscripciones Progrs',t:0},
              {id:3,nom:'-',t:'-'},
              {id:4,nom:'Cursos',t:0},
              {id:5,nom:'Matriculas',t:0},
              {id:6,nom:'Colegiaturas',t:0},
              {id:7,nom:'Total Bs',t:0},
            ],
            totalcursos: 0,
            totalprogs: 0,
          } 
        ) 
      });

      //this.clickBuscar(); // opcional
    },
    'sede.idsede': function(){
      //this.usuarios =[]
    }
  },
  methods:{
    clickBuscar(){
      if( !this.busqueda.fecha_ini || !this.busqueda.fecha_fin || this.sede.idusuario.length == 0 ){
        this.$notify( error( 'Faltan parametros','Complete los campos' ) )
        return;
      }

      this.semaforoistener();
    },
    parseUs( dp ){ //datos_personales
			if( dp == null ) return "-";
      if( dp.pri_apellido== null ) dp.pri_apellido = "";
      if( dp.seg_apellido== null ) dp.seg_apellido = "";
			return dp.nombres+" "+dp.pri_apellido+" "+dp.seg_apellido;
    },
    parseTotal(){ return 0; },

    semaforoistener(){
      var vue = this;
      this.usuarios.forEach( function(e){
        vue.getInscripciones( e )
      });
    },

    async getInscripciones( user ){
      var vue = this;
      var sql = gql`query{ getInscripcionesByUser(user:${user.id},fechas:{fecha_ini:"${this.busqueda.fecha_ini}",fecha_fin:"${this.busqueda.fecha_fin}"}){id,estado_ins,monto_matricula,programa{postgrado{nombre,idcategoria,categoria{id,nombre}},inscripciones{asesor{id},matricula{monto,saldo},cuotas_canceladas{monto,saldo} }}} }`
      window.console.log( ">>>>>>>>>>>>> ",sql );
      this.$refs.alertar.cargando();
      user.loading = true;

      vue.totales.a = 0;
      vue.totales.b = 0;
      vue.totales.c = 0;
      vue.totales.d = 0;
      vue.totales.e = 0;
      vue.totales.aa = 0;
      vue.totales.bb = 0;
      vue.totales.cc = 0;
      vue.totales.dd = 0;
      vue.totales.aaa = 0;
      vue.totales.bbb = 0;
      vue.totales.ccc = 0;
      vue.totales.ddd = 0;

      await this.$apollo.query({
        query: sql,
        }).then((data) => {
          var lista = data.data.getInscripcionesByUser;
          lista = lista.filter( function(e){ return e.estado_ins > 0 })
          //window.console.log( ">>>>>>>>>>>>> ",window.stringifyObject(lista) );

          var usu = vue.usuarios.find( x => x.id == user.id );
          if( usu ){
            var a = [];
            var b = [];
            var c = [];
            var d = [];
            var aa = [];
            var bb = [];
            var cc = [];
            var dd = [];
            var matris = 0;
            var matris2 = 0;
            var matris3 = 0;
            var matris4 = 0;
            var coles = 0;
            var coles2 = 0;
            var coles3 = 0;
            //var nom = '';


            lista.forEach( function(e){
              //nom += e.programa.postgrado.categoria.nombre+'-'+e.programa.postgrado.nombre+', ';
              var mio = e.programa.inscripciones.find( x => x.asesor.id == user.id)
              mio.cuotas_canceladas = [];
              var cursito = /*e.programa.postgrado.categoria.nombre +' '+*/e.programa.postgrado.nombre;
              var cobro = 0;
              window.console.log( ">>>>>>>>>>>>> ",window.stringifyObject(mio) );

              //pagos de matriculas y colegiaturas de, diplo, espe, maes
              if(e.programa.postgrado.categoria.id==1) {
                aa.push( e.id );
                var exi = a.find( x => x.curso == cursito);
                if( exi ) {
                  if( mio.matricula ) { exi.matri += mio.matricula.monto;matris += mio.matricula.monto; }
                  //exi.cobro += cobro;
                  exi.count +=1; 
                }
                else a.push( {curso:cursito,cobro:cobro,count:1,matri:0} )
              }
              else if(e.programa.postgrado.categoria.id==2) {
                bb.push( e.id );
                var exi2 = b.find( x => x.curso == cursito);
                if( exi2 ) {
                  if( mio.matricula ) { exi2.matri += mio.matricula.monto;matris2 += mio.matricula.monto; }
                  //exi2.cobro += cobro;
                  exi2.count +=1; 
                }
                else b.push( {curso:cursito,cobro:cobro,count:1,matri:0} )
              }
              else if(e.programa.postgrado.categoria.id==3) {
                cc.push( e.id );
                var exi3 = c.find( x => x.curso == cursito);
                if( exi3 ) {
                  if( mio.matricula ) { exi3.matri += mio.matricula.monto;matris3 += mio.matricula.monto; }
                  //exi3.cobro += cobro;
                  exi3.count +=1; 
                }
                else c.push( {curso:cursito,cobro:cobro,count:1,matri:0} )
              }
              // fin pago de diplo, espe, maes

              //verificar cobros
              mio.cuotas_canceladas.forEach( function(e){ cobro += ( /*e.monto -*/ (e.monto-e.saldo)) })
              //window.console.log( "MMMM",mio )
              if(e.programa.postgrado.categoria.id==1) {
                //aa.push( e.id );
                var ex = a.find( x => x.curso == cursito);
                if( ex ) {ex.cobro += cobro; coles += cobro; }
                else a.push( {curso:cursito,cobro:cobro,count:1} )
              }
              else if(e.programa.postgrado.categoria.id==2) {
                //bb.push( e.id );
                var ex2 = b.find( x => x.curso == cursito);
                if( ex2 ) {ex2.cobro += cobro; coles2 += cobro; }
                else b.push( {curso:cursito,cobro:cobro,count:1} )
              }
              else if(e.programa.postgrado.categoria.id==3) {
                //cc.push( e.id );
                var ex3 = c.find( x => x.curso == cursito);
                if( ex3 ) {ex3.cobro += cobro; coles3 += cobro; }
                else c.push( {curso:cursito,cobro:cobro,count:1} )
              }
              else if(e.programa.postgrado.categoria.id==5) {
                dd.push( e.id );
                var ex4 = d.find( x => x.curso == cursito);
                if( ex4 ) {ex4.cobro += cobro;ex4.count +=1;matris4 = ex4.cobro;  } // aqui tal ves falle las sumas de crsos
                else d.push( {curso:cursito,cobro:cobro,count:1} )
              }
            });


            var completarTam = a.length
            if( b.length > completarTam ) completarTam = b.length
            if( c.length > completarTam ) completarTam = c.length
            if( d.length > completarTam ) completarTam = d.length
            if( completarTam == 0 ) completarTam = 6;
            else if( completarTam < 6 ) completarTam += 6 - completarTam;
            for( var i=a.length;i<completarTam;i++ ) a.push( {curso:'.',matri:'.',cobro:'.',count:'.'} )
            for( var i2=b.length;i2<completarTam;i2++ ) b.push( {curso:'.',matri:'.',cobro:'.',count:'.'} )
            for( var i3=c.length;i3<completarTam;i3++ ) c.push( {curso:'.',matri:'.',cobro:'.',count:'.'} )
            for( var i4=d.length;i4<completarTam;i4++ ) d.push( {curso:'.',matri:'.',cobro:'.',count:'.'} )

            a.push( {curso:'.',matri:matris,cobro:coles,count:aa.length} ) // cantidades totales de cada asesor
            b.push( {curso:'.',matri:matris2,cobro:coles2,count:bb.length} )
            c.push( {curso:'.',matri:matris3,cobro:coles3,count:cc.length} )
            d.push( {curso:'.',matri:'*',cobro:matris4,count:dd.length} )

            user.ca = a;
            user.cb = b;
            user.cc = c;
            user.cd = d;
            user.meta1 = aa.length; 
            user.meta2 = bb.length;
            user.meta3 = cc.length;
            user.meta4 = dd.length;
            user.loading = false;
            user.tots.find( x => x.id == 1 ).t = dd.length;
            user.tots.find( x => x.id == 2 ).t = (aa.length+bb.length+cc.length);
            user.tots.find( x => x.id == 4 ).t = matris4;
            user.tots.find( x => x.id == 5 ).t = (matris+matris2+matris3);
            user.tots.find( x => x.id == 6 ).t = (coles+coles2+coles3);
            user.tots.find( x => x.id == 7 ).t = (coles+coles2+coles3) + (matris+matris2+matris3) +matris4;

            user.total = user.meta1+user.meta2+user.meta3/*+user.meta4*/;
            user.totalm = matris+matris2+matris3;
            user.totalc = coles+coles2+coles3;
            vue.totales.a += user.meta1;
            vue.totales.b += user.meta2;
            vue.totales.c += user.meta3;
            vue.totales.d += user.meta4;
            vue.totales.e += user.total;
            vue.totales.ee += user.totalm;
            vue.totales.eee += user.totalc;

            vue.totales.dd += matris4;
            vue.totales.aa += (matris+matris2+matris3);
            vue.totales.aaa += (coles+coles2+coles3);
            //user.nom = nom;
            window.console.log( "MMMM",user )
          }

          //window.console.log( "--------------------------",user );
          this.$refs.alertar.reset();
        }).catch((error) => {
          vue.$refs.alertar.reset();
          window.console.error(error)
          this.$notify( parseJsonError( error,'getInscripcionesByUser' ) )
        })
    },
  },
  mounted(){
    var date = new Date();
    var date2 = new Date();
    date.setDate( date.getDate()-7 )
    var d1 = date.getDate()
    var m1 = date.getMonth()+1
    var d2 = date2.getDate()
    var m2 = date2.getMonth()+1
    if( d1 < 10 ) d1 = '0'+d1;
    if( m1 < 10 ) m1 = '0'+m1;
    if( d2 < 10 ) d2 = '0'+d2;
    if( m2 < 10 ) m2 = '0'+m2;

    var f1 = date.getFullYear()+'-'+m1+'-'+d1;
    var f2 = date2.getFullYear()+'-'+m2+'-'+d2;

    this.busqueda.fecha_ini = f1;
    this.busqueda.fecha_fin = f2;
  }
}
</script>